//------- import libraries
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";

//------- import custom reuseable components
import ToggleButtonWithText from "../toggleButtons/ToggleButtonWithText";
import ShopifySelectDropdown from "../selectDropdown/ShopifySelectDropdown";
import ProductShopifyMappingSettingModal from "./ProductShopifyMappingSettingModal";

//------- import icons
import { ReactComponent as ShopifyLogo } from "../../../assets/images/ShopifyLogoWhite.svg";

//------- import constants
import {
  EMPTY_STRING,
  getProductStatistics,
  SHOPIFY_STATUS_OPTIONS,
} from "../../../constants";

//------ import utility functions
import {
  isShopifyConnected,
  parseToThousandSeperatorWholeNumber,
  parseToThousandSeperatorDecimalNumber,
} from "../../utility";

const AddEditInventoryModalPricesHistoryStats = (props) => {
  // initializations
  const {
    currentStore,
    productDataObject,
    isBatchProduct = false,
    setProductDataObject = () => {},
    isShowInStoreOnlineQuantityCheck = false,
    handleStoreAndOnlineQuantityChange,
    handleCustomShopifyStatusChange = () => {},
  } = props;


  //------- isShopifyConnected
  const isShopifyStoreConnected = isShopifyConnected(currentStore);

  //------- useStates
  const [isNetworkStats, setIsNetworkStats] = useState(false);
  const [shopifyStatus, setShopifyStatus] = useState(
    productDataObject?.isLinkToShopify
      ? SHOPIFY_STATUS_OPTIONS[0]
      : SHOPIFY_STATUS_OPTIONS[1]
  );

  //-------Handle Shopfiy Status Change
  const handleShopifyStatusChange = (option) => {
    setProductDataObject((prevState) => ({
      ...prevState,
      isLinkToShopify: option.value,
    }));
  };

  //------- handle shopify status chnage
  const handleStatusChange = (option) => {
    setShopifyStatus(option);
    handleCustomShopifyStatusChange(option);
    handleShopifyStatusChange(option);
  };

  //------- handle toggle network tabs
  const toggleNetworkStats = () => {
    setIsNetworkStats((prev) => !prev);
  };

  useEffect(() => {
    setShopifyStatus(
      productDataObject.isLinkToShopify
        ? SHOPIFY_STATUS_OPTIONS[0]
        : SHOPIFY_STATUS_OPTIONS[1]
    );
  }, [productDataObject?.isLinkToShopify]);

  return (
    <Row className="m-0 add-inventory-prices-detail-wrapper p-3">
      {isShopifyStoreConnected && (
        <Col md={12} className=" ">
          <div className="d-flex flex-column w-100 gap-3 pb-3 border-bottom">
            <div className=" w-100 d-flex justify-content-between align-items-center">
              <ShopifyLogo width={150} height={"auto"} />
              {shopifyStatus.value && (
                <ProductShopifyMappingSettingModal
                  productDataObject={productDataObject}
                  setProductDataObject={setProductDataObject}
                  isBatchProduct={isBatchProduct}
                  handleShopifyMappingOpen={handleCustomShopifyStatusChange}
                  handleCustomShopifyStatusChange={
                    handleCustomShopifyStatusChange
                  }
                  isShowInStoreOnlineQuantityCheck={
                    isShowInStoreOnlineQuantityCheck
                  }
                  handleStoreAndOnlineQuantityChange={
                    handleStoreAndOnlineQuantityChange
                  }
                />
              )}
            </div>
            <ShopifySelectDropdown
              options={SHOPIFY_STATUS_OPTIONS}
              selectedValue={shopifyStatus}
              handleChange={handleStatusChange}
            />
          </div>
        </Col>
      )}
      <Col md={12} className="pt-3 product-statistics-heading">
        Product Statistics
      </Col>
      <Col
        md={12}
        className="add-inventory-prices-detail-wrapper product-stats-con-height container-scrollbar d-flex flex-column align-items-lg-stretch"
      >
        {getProductStatistics(isNetworkStats, productDataObject).map(
          (element) =>
            element.isVisible && (
              <div className="price-stat-con">
                <span className="price-stat-heading">{element.title}</span>
                <span>
                  {element.isDollarSign === false ? EMPTY_STRING : "$ "}
                  {Number(element.value) <= 0
                    ? "-"
                    : element.isWholeNumber
                    ? parseToThousandSeperatorWholeNumber(element.value)
                    : parseToThousandSeperatorDecimalNumber(element.value)}
                </span>
              </div>
            )
        )}
      </Col>

      {/* <Col md={12}>
        <ToggleButtonWithText
          isToggle={isNetworkStats}
          handleLeftButtonClick={toggleNetworkStats}
          handleRightButtonClick={toggleNetworkStats}
          leftButtonLabel="Your Store"
          rightButtonLabel="Network"
          className="discount-toggle-button add-inventory-quantity-toggle-switch network-statas-toggle-button"
        />
      </Col> */}
    </Row>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  currentStore: state.store.currentStore,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditInventoryModalPricesHistoryStats);
